const mandatoryFinancedAssetFields = [
  { key: 'assetTypeId', value: 'OfferEdit.Asset.Info.AssetType' },
  { key: 'acquisitionPriceWithoutVat', value: 'OfferEdit.Asset.Financial.AcquisitionPriceWithoutVat' },
  { key: 'acquisitionPriceWithVat', value: 'OfferEdit.Asset.Financial.AcquisitionPriceWithVat' },
  { key: 'currencyId', value: 'OfferEdit.Asset.Financial.Currency' },
  { key: 'quantity', value: 'OfferEdit.Asset.Financial.Quantity' }
];

const mandatoryDealerAssetFields = [{ key: 'dealerId', value: 'OfferEdit.Asset.Partner.Dealer' }];

const mandatorySupplierAssetFields = [
  { key: 'supplierId', value: 'OfferEdit.Asset.Partner.Supplier' },
  { key: 'registrationCode', value: 'OfferEdit.Asset.Partner.RegistrationCode' }
];

const supplierType = {
  Other: 0,
  Dealer: 1,
  Client: 2
};

export { mandatoryFinancedAssetFields, mandatoryDealerAssetFields, mandatorySupplierAssetFields, supplierType };
